export const {
  REACT_APP_API_URL,
  REACT_APP_BASE_BACKEND_URL,
  REACT_APP_MAX_FILE_SIZE_UPLOAD,
  APP_TIMEZONE,
} = process.env;
